import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineChevronRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import {
  integrationCatalog,
  IntegrationKey,
} from "../../../integrations/catalog";

const keys: IntegrationKey[] = [
  "tripletex",
  ...(process.env.REACT_APP_SHOPIFY_INTEGRATION_ENABLED === "true"
    ? (["shopify"] as IntegrationKey[])
    : []),
  "logibud-mcp",
];

const IntegrationsOverviewContent: FC = () => {
  const { t } = useTranslation("workspace");
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-text sm:text-2xl">
          {t("integrations.title")}
        </h2>
        <p className="max-w-2xl pt-2 text-base text-secondary">
          {t("integrations.overview_description")}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-2" role="list">
        {keys.map((key) => {
          const integration = integrationCatalog[key];
          const isMcp = key === "logibud-mcp";
          return (
            <button
              key={key}
              type="button"
              role="listitem"
              onClick={() =>
                navigate(
                  isMcp
                    ? "/settings?tab=mcp-tokens"
                    : `/settings/integrations/${key}`,
                )
              }
              className="group flex min-h-[132px] w-full items-center gap-5 rounded-lg border border-border bg-surface p-5 text-left transition hover:border-brand hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-brand"
            >
              <div className="flex h-14 w-20 shrink-0 items-center justify-center overflow-hidden rounded-md bg-white p-2">
                <img
                  src={
                    integration.cardAsset === "emblem" && integration.emblemSrc
                      ? integration.emblemSrc
                      : integration.logoSrc
                  }
                  alt=""
                  className="max-h-full max-w-full object-contain"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-base font-semibold text-text">
                  {integration.name}
                </h3>
                <p className="mt-1 text-sm leading-6 text-secondary">
                  {t(`integrations.catalog.${key}.description`)}
                </p>
              </div>
              <HiOutlineChevronRight className="h-5 w-5 shrink-0 text-secondary transition group-hover:translate-x-0.5 group-hover:text-brand" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default IntegrationsOverviewContent;
